<!--
     Copyright (c) 2024-2026 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<a *ngIf="!navItem.childItems"
   clrVerticalNavLink
   [routerLink]="navItem.routerLink"
   routerLinkActive="active"
   class="nav-link"
   dr-set-aria-current
   dr-show-title>
    <cds-icon *ngIf="navItem.iconShape" clrVerticalNavIcon
              [shape]="navItem.iconShape"
              [attr.aria-hidden]="true"
              [ngClass]="{'nav-sub-group-item': subItemStyle}"
              size="sm">
    </cds-icon>
    {{ navItem.l10nKey | vtranslate }}
</a>
